import { Component, OnInit, Input, LOCALE_ID, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

export interface Breadcrumb {
  label: string;
  url: string;
}

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  pageTitle: string;
  progressBar: string;
  addLink: string;
  showBreadCrumb: boolean = false;
  showAdmin: boolean = false;  

  breadcrumbs: Breadcrumb[] = new Array();
  static ROUTE_DATA_BREADCRUMB: string = "breadcrumb";

  constructor(private activatedRoute: ActivatedRoute, private router: Router,
    @Inject(LOCALE_ID) public locale: string) { }

  ngOnInit() {
    this.activatedRoute.paramMap.subscribe(() => {
        this.breadcrumbs = this.createBreadcrumbs(this.activatedRoute.root);
      });
  }

  @Input()
  public set titleText(value: string) {
    if (value) {
      this.pageTitle = value.toUpperCase();
    }
  }

  @Input()
  public set isAdmin(value: boolean) {
    if (value) {
      this.showAdmin = value;
    }
  }

  @Input()
  public set progressBarState(value: string) {
    if (value) {
      switch (value) {
        case 'lead':
          this.progressBar = `assets/img/progress_bar/${this.locale}/progress_lead.png`;
          break;
        case 'quote':
          this.progressBar = `assets/img/progress_bar/${this.locale}/progress_quote.png`;
          break;
        case 'job':
          this.progressBar = `assets/img/progress_bar/${this.locale}/progress_job.png`;
          break;
        case 'workorder':
          this.progressBar = `assets/img/progress_bar/${this.locale}/progress_work_order.png`;
          break;
        default:
          this.progressBar = null;
      }
    }
  }

  navigate(breadcrumb: Breadcrumb) {
    this.router.navigate([breadcrumb.url]);
  }

  private createBreadcrumbs(route: ActivatedRoute, url: string = '', breadcrumbs: Breadcrumb[] = []): Breadcrumb[] {
    const children: ActivatedRoute[] = route.children;

    if (children.length === 0) {
      return breadcrumbs;
    }

    for (const child of children) {
      const routeURL: string = child.snapshot.url.map(segment => segment.path).join('/');
      if (routeURL !== '') {
        url += `/${routeURL}`;
      }

      const label = child.snapshot.data[HeaderComponent.ROUTE_DATA_BREADCRUMB + '_' + this.locale];
      if (label) {
        breadcrumbs.push({ label, url });
      }

      return this.createBreadcrumbs(child, url, breadcrumbs);
    }
  }
}
